// Product card images: hovering the card (mouse) crossfades to the second image;
// on touch, a horizontal swipe crossfades between images. Opacity only, no sliding.
class SCardGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.images = [...this.querySelectorAll('[data-gallery-image]')];
    this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
    if (this.images.length < 2) return;

    this.index = 0;
    const card = this.closest('article') || this;

    card.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') this.#show(1);
    }, { signal });
    card.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') this.#show(0);
    }, { signal });

    let startX = 0;
    let startY = 0;
    let tracking = false;
    card.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      const rect = this.getBoundingClientRect();
      tracking = event.clientY >= rect.top && event.clientY <= rect.bottom;
      startX = event.clientX;
      startY = event.clientY;
    }, { signal });
    card.addEventListener('pointerup', (event) => {
      if (!tracking) return;
      tracking = false;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const forward = rtl ? dx > 0 : dx < 0;
      const count = this.images.length;
      this.#show((this.index + (forward ? 1 : -1) + count) % count);
    }, { signal });
    card.addEventListener('pointercancel', () => { tracking = false; }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  #show(next) {
    this.index = next;
    this.images.forEach((image, i) => image.toggleAttribute('data-active', i === next));
    this.dots.forEach((dot, i) => dot.toggleAttribute('data-active', i === next));
  }
}

customElements.define('s-card-gallery', SCardGallery);
